// 📍 MapCompteurSelector.jsx
import {
  GoogleMap,
  Polygon,
  Marker,
  InfoWindow
} from '@react-google-maps/api';
import { useEffect, useState } from 'react';
import axios from 'axios';

const containerStyle = {
  width: '100%',
  height: '400px'
};

const defaultCenter = {
  lat: 34.536761,
  lng: -4.638178
};

const getColorByIndex = (index) => {
  const colors = [
    '#FF5722', '#3F51B5', '#009688', '#FFC107', '#E91E63',
    '#4CAF50', '#9C27B0', '#00BCD4', '#CDDC39', '#795548'
  ];
  return colors[Math.floor(Math.random() * colors.length)];
};

export default function MapCompteurSelector({ secteurId, position, onSelect }) {
  const [secteur, setSecteur] = useState(null);
  const [infoWindowPos, setInfoWindowPos] = useState(null);

  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchSecteur = async () => {
      if (!secteurId) return setSecteur(null);

      try {
        const res = await axios.get(`http://localhost:5000/api/secteurs/${secteurId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        const data = res.data;
        if (data?.coords?.length > 0) {
          const coords = data.coords.map(coord => ({
            lat: parseFloat(coord.lat),
            lng: parseFloat(coord.lng)
          }));

          setSecteur({
            nom: data.nom,
            coords,
            color: getColorByIndex()
          });
        } else {
          setSecteur(null);
        }
      } catch (err) {
        console.error('Erreur récupération secteur :', err);
        setSecteur(null);
      }
    };

    fetchSecteur();
  }, [secteurId, token]);

  const center = position || (secteur?.coords?.[0]) || defaultCenter;

  return (
    <div style={{ marginTop: '10px' }}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={15}
        onClick={(e) => {
          const lat = e.latLng.lat();
          const lng = e.latLng.lng();
          onSelect({ lat, lng });
        }}
      >
        {secteur?.coords?.length > 0 && (
          <Polygon
            paths={secteur.coords}
            options={{
              fillColor: secteur.color,
              fillOpacity: 0.3,
              strokeColor: secteur.color,
              strokeOpacity: 0.8,
              strokeWeight: 2
            }}
            onClick={(e) => {
              setInfoWindowPos(e.latLng.toJSON());
            }}
          />
        )}

        {infoWindowPos && (
          <InfoWindow
            position={infoWindowPos}
            onCloseClick={() => setInfoWindowPos(null)}
          >
            <div><strong>{secteur?.nom}</strong></div>
          </InfoWindow>
        )}

        {position && <Marker position={position} />}
      </GoogleMap>

      <p style={{ fontSize: '0.9rem', marginTop: '10px' }}>
        {position
          ? `Position compteur : ${position.lat.toFixed(6)}, ${position.lng.toFixed(6)}`
          : 'Cliquez sur la carte pour positionner le compteur.'}
      </p>
    </div>
  );
}
